// extracted by mini-css-extract-plugin
export default {"upload":"UploadFileUI_upload__ro+TR","text":"UploadFileUI_text__OWDfU"};